"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornmentLeft = void 0;
var _AdornmentLeft = require("./AdornmentLeft");
// TODO: in v9, move styled() from AdornmentLeft.jsx to here
var StyledAdornmentLeft = _AdornmentLeft.AdornmentLeft;
exports.StyledAdornmentLeft = StyledAdornmentLeft;